var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CaretUp",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M44,42.67c2.2,0,2.92-1.44,1.6-3.2L34.4,24.53a2.84,2.84,0,0,0-4.8,0L18.4,39.47c-1.32,1.76-.6,3.2,1.6,3.2Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/caret_up.svg